import React from 'react';
import PersonalTaskForm from '../PersonalTaskForm';

const EditPersonalTaskForm = (props) => {
    return <PersonalTaskForm {...props} />;
};

export default EditPersonalTaskForm;
